import { render, staticRenderFns } from "./gk-form.vue?vue&type=template&id=1c6e4325"
import script from "./gk-form.vue?vue&type=script&lang=js"
export * from "./gk-form.vue?vue&type=script&lang=js"
import style0 from "./gk-form.vue?vue&type=style&index=0&id=1c6e4325&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports